import React, { useRef } from 'react';
import { observer } from 'mobx-react';

import { analytics } from 'core/analytics';

import { useContextManager } from 'apps/context/hooks';
import { useChatControl } from 'libs/rendering/hooks';

import { routerStore } from 'core/routing';

import { Panel } from '../panel';
import ChatInput from './chatInput';
import Chat from './chat';

const ChatPanel = observer(() => {
  const contextManager = useContextManager();
  const chatControl = useChatControl();
  const chatRef = useRef(null);

  if (!contextManager) return null;
  if (!chatControl.chatVisible) return null;

  const onScrollToBottomClicked = () => {
    if (chatRef?.current) {
      chatRef.current.scrollToBottom();
    }
  };

  return (
    <Panel
      position='right'
      title='Chat log'
      iconName='chat_multiple'
      removeHeader
      collapseAction={() => {
        const newParams = Object.assign({}, routerStore.route.params);
        if (newParams.panel === 'discuss') delete newParams.panel;
        else newParams.panel = 'discuss';
        routerStore.navigate(routerStore.route.name, newParams, {
          replace: true,
        });

        analytics.sendEvent('viewer-chat-collapse');
      }}
      isOpen={chatControl.chatVisible}
      footer={<ChatInput onScrollBottom={onScrollToBottomClicked} />}
    >
      <Chat ref={chatRef} />
    </Panel>
  );
});

export default ChatPanel;
